module.exports = __webpack_public_path__ + "img/blogpost3.266fe451.jpg";